import React from 'react';
import background from '../../assets/hurricanes.jpg';
import ReusableInfoCard from '../../components/ReusableInfoCard/ReusableInfoCard';

class InfoHurricanes extends React.Component {
  render () { 
   return(
  
  <ReusableInfoCard             
    
        tag="ATMOSPHERE"
        description="Hurricanes"
        paragraph="Hurricanes are large, swirling storms that form over warm ocean waters. If a hurricane reaches land, it pushes a wall of ocean water ashore (storm surge). Heavy rain and storm surge from a hurricane can cause flooding (NASA)."
        coverbackground={background}
     />
  
  );
 }
}   

export default InfoHurricanes;